import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import moment from 'moment';
import Select from 'react-select-box';
import _ from 'lodash';
import FinancialStoriesStore from '../../stores/FinancialStoriesStore';
import AccountsStore from '../../stores/AccountsStore';
import SvgIcon from '../common/SvgIcon';
import FinancialStoriesActionCreator from '../../actions/FinancialStoriesActionCreator';
import InternetBankingActions from '../../actions/InternetBankingActions';
import NumberUtils from '../../utils/NumberUtils';
import AnalyticsUtil from '../../utils/AnalyticsUtil';
import BrowserUtils from '../../utils/BrowserUtils';
import FinancialStoriesBL from './AccountDetailsNew/FinancialStoriesBL';
import config from '../../config/index';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import ErrorPopUpComponent from '../common/ErrorPopUpComponent';
import PatternLibModalComponent from './AccountDetailsNew/PatternLibModalComponent';
import envConfig from '../../../static/config';
import OrientationSwitch from '../common/OrientationSwitch';
import { backgroundColorMap } from '../../utils/ui-utils';

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

class TileComponent extends React.Component {
  constructor(props) {
    super(props);
    this.onMonthChange = this.onMonthChange.bind(this);
    this.getFSTransactionServiceCall =
      this.getFSTransactionServiceCall.bind(this);
    this.getTileData = this.getTileData.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.getPanelData = this.getPanelData.bind(this);
    this.getHeader = this.getHeader.bind(this);
    this.eventsCall = this.eventsCall.bind(this);
    this.inProgressPopUp = this.inProgressPopUp.bind(this);
    this.tileComponentView = this.tileComponentView.bind(this);
    this.state = {
      selectedMonth: 0,
      tileType: FinancialStoriesStore.getTileType(),
      account: AccountsStore.getAccount(),
      tileData: {},
      showError: FinancialStoriesStore.getErrorFlag(),
      inProgressFlag: false,
    };
  }

  componentWillMount() {
    BrowserUtils.setViewPort(1);
    this.getTileData();
    FinancialStoriesStore.addChangeListener(this.onStoreChange);

    if (envConfig.brandId !== 'VM') {
      document.body.style.backgroundColor =
        backgroundColorMap[envConfig.brandId];
    }
  }

  componentDidMount() {
    this.getFSTransactionServiceCall(0);
    this.eventsCall();
  }

  componentWillUnmount() {
    FinancialStoriesStore.removeChangeListener(this.onStoreChange);
    document.body.style.backgroundColor = '';
  }

  onMonthChange(e) {
    const actualMonth = parseInt(e);
    this.getFSTransactionServiceCall(actualMonth);
    this.setState({ selectedMonth: actualMonth });
  }

  onStoreChange() {
    this.getTileData();
    this.setState({ showError: FinancialStoriesStore.getErrorFlag() });
  }

  getFSTransactionServiceCall(actualMonth) {
    const datePacket = FinancialStoriesBL.getMonthData(actualMonth);
    switch (this.state.tileType) {
      case 'microTransactions':
        const fsData = FinancialStoriesStore.getMicroTransactions(
          this.state.account,
          datePacket.month
        );
        if (fsData && fsData.transactionCount !== fsData.transactions.length) {
          FinancialStoriesActionCreator.getMicroTransactions(
            this.state.account,
            datePacket,
            fsData.transactionCount
          );
        } else if (fsData) {
          this.setState({ tileData: fsData, selectedMonth: actualMonth });
        } else {
          this.setState({ tileData: '', selectedMonth: actualMonth });
        }
        break;
      case 'insAndOuts':
        const fsData1 = FinancialStoriesStore.getInsAndOuts(
          this.state.account,
          datePacket.month
        );
        if (
          fsData1 &&
          fsData1.transactionCount !== fsData1.transactions.length
        ) {
          FinancialStoriesActionCreator.getInsAndOuts(
            this.state.account,
            datePacket,
            fsData1.transactionCount
          );
        } else if (fsData1) {
          this.setState({ tileData: fsData1, selectedMonth: actualMonth });
        } else {
          this.setState({ tileData: '', selectedMonth: actualMonth });
        }
        break;
      case 'cashpoint':
        const fsData2 = FinancialStoriesStore.getCashpoint(
          this.state.account,
          datePacket.month
        );
        if (
          fsData2 &&
          fsData2.transactionCount !== fsData2.transactions.length
        ) {
          FinancialStoriesActionCreator.getCashpoint(
            this.state.account,
            datePacket,
            fsData2.transactionCount
          );
        } else if (fsData2) {
          this.setState({ tileData: fsData2, selectedMonth: actualMonth });
        } else {
          this.setState({ tileData: '', selectedMonth: actualMonth });
        }
        break;
    }
  }

  getFooter() {
    switch (this.state.tileType) {
      case 'microTransactions':
        let text1 = '';
        if (this.state.tileData && this.state.tileData.avgAmount !== 0) {
          text1 = this.props.content.micro_footerText;
          text1 = _.replace(
            text1,
            '{sum}',
            NumberUtils.appendCurrency('{}', this.state.tileData.avgAmount * -1)
          );
        }
        return text1;
      case 'cashpoint':
        let text2 = '';
        if (this.state.tileData && this.state.tileData.minAmount !== 0) {
          text2 = this.props.content.cashpoint_footerText;
          text2 = _.replace(
            text2,
            '{sum}',
            NumberUtils.appendCurrency('{}', this.state.tileData.minAmount * -1)
          );
        }
        return text2;
      case 'insAndOuts':
        let text3 = '';
        if (this.state.tileData) {
          text3 = this.props.content.inAndOutFootrText;
          text3 = _.replace(
            text3,
            '{credit}',
            NumberUtils.appendCurrency('{}', this.state.tileData.creditAmount)
          );
          text3 = _.replace(
            text3,
            '{debit}',
            NumberUtils.appendCurrency(
              '{}',
              this.state.tileData.debitAmount * -1
            )
          );
          if (this.state.tileData.sumAmount > 0) {
            text3 = _.replace(text3, '{only}', 'only');
          } else {
            text3 = _.replace(text3, '{only}', '');
          }
        } else {
          text3 = this.props.content.inAndOutFootrText;
          text3 = _.replace(
            text3,
            '{credit}',
            NumberUtils.appendCurrency('{}', 0)
          );
          text3 = _.replace(
            text3,
            '{debit}',
            NumberUtils.appendCurrency('{}', 0)
          );
          text3 = _.replace(text3, '{only}', '');
        }
        return text3;
    }
  }

  getHeader() {
    switch (this.state.tileType) {
      case 'microTransactions':
        let text1 = '';
        if (this.state.tileData && this.state.tileData.sumAmount !== 0) {
          this.state.tileData.month === moment().format('YYYY-MM')
            ? (text1 = this.props.content.micro_headerTextCurrentMonthWithSum)
            : (text1 = this.props.content.micro_headerTextOtherMonthsWithSum);
          text1 = _.replace(
            text1,
            '{sum}',
            NumberUtils.appendCurrency('{}', this.state.tileData.sumAmount * -1)
          );
        } else {
          this.state.selectedMonth === 0
            ? (text1 = this.props.content.micro_headerTextCurrentMonth)
            : (text1 = this.props.content.micro_headerTextOtherMonths);
        }
        return `${text1}`;
      case 'cashpoint':
        let text2 = '';
        if (this.state.tileData && this.state.tileData.sumAmount !== 0) {
          this.state.tileData.month === moment().format('YYYY-MM')
            ? (text2 = this.props.content.cashpoint_headerTextCurrentMonthSum)
            : (text2 = this.props.content.cashpoint_headerTextOtherMonthsSum);
          text2 = _.replace(
            text2,
            '{sum}',
            NumberUtils.appendCurrency('{}', this.state.tileData.sumAmount * -1)
          );
        } else {
          this.state.selectedMonth === 0
            ? (text2 = this.props.content.cashpoint_headerTextCurrentMonth)
            : (text2 = this.props.content.cashpoint_headerTextOtherMonths);
        }
        return `${text2}`;
      case 'insAndOuts':
        let text3 = '';
        if (this.state.tileData && this.state.tileData.sumAmount < 0) {
          this.state.tileData.month === moment().format('YYYY-MM')
            ? (text3 =
                this.props.content.inAndOut_headerTextCurrentMonthNegativeSum)
            : (text3 =
                this.props.content.inAndOut_headerTextOtherMonthsNegativeSum);
          text3 = _.replace(
            text3,
            '{sum}',
            NumberUtils.appendCurrency('{}', this.state.tileData.sumAmount * -1)
          );
        } else if (this.state.tileData && this.state.tileData.sumAmount > 0) {
          this.state.tileData.month === moment().format('YYYY-MM')
            ? (text3 =
                this.props.content.inAndOut_headerTextCurrentMonthPositiveSum)
            : (text3 =
                this.props.content.inAndOut_headerTextOtherMonthsPositiveSum);
          text3 = _.replace(
            text3,
            '{sum}',
            NumberUtils.appendCurrency('{}', this.state.tileData.sumAmount)
          );
        } else {
          this.state.selectedMonth === 0
            ? (text3 = this.props.content.inAndOut_headerTextCurrentMonth)
            : (text3 = this.props.content.inAndOut_headerTextOtherMonths);
        }
        return `${text3}`;
    }
  }

  getMonthsList() {
    const _monthsList = [];
    const monthStartDay = 0;
    let monthNameCalculation;
    if (Number(monthStartDay) === Number(moment().format('DD'))) {
      for (let i = 0; i < 5; i++) {
        monthNameCalculation = Number(moment().format('MM') - (i + 2));
        if (i === 0) {
          _monthsList.push(<option value={i}>last month</option>);
        } else {
          _monthsList.push(
            <option value={i}>{`in ${_.nth(
              monthNames,
              monthNameCalculation
            )}`}</option>
          );
        }
      }
    } else {
      for (let i = 0; i < 6; i++) {
        monthNameCalculation = Number(moment().format('MM') - (i + 1));
        if (i === 0) {
          _monthsList.push(<option value={i}>this month</option>);
        } else if (i === 1) {
          _monthsList.push(<option value={i}>last month</option>);
        } else {
          _monthsList.push(
            <option value={i}>{`in ${_.nth(
              monthNames,
              monthNameCalculation
            )}`}</option>
          );
        }
      }
    }
    return _monthsList;
  }

  getPanelData() {
    let TotalTransactions = '';
    if (this.state.tileData && this.state.tileData.transactions.length > 0) {
      if (
        this.state.tileData.transactions.length ===
        this.state.tileData.transactionCount
      ) {
        TotalTransactions = _.map(
          this.state.tileData.transactions,
          (transaction, i) => {
            return (
              <tr key={i}>
                <td width="15%">{transaction.date}</td>
                <td width="30%">
                  <strong> {transaction.description}</strong>
                </td>
                <td width="20%"> {transaction.type} </td>
                <td width="20%">
                  {transaction.posted ? (
                    <span className="icon icon-tag">{transaction.tag}</span>
                  ) : (
                    <span
                      className="transaction-pending"
                      onClick={this.inProgressPopUp}
                    >
                      <svg
                        enableBackground="new 0 0 91 91"
                        height="28px"
                        id="Layer_1"
                        version="1.1"
                        viewBox="0 0 91 91"
                        width="28px"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g>
                          <path d="M45.2,18.577c-15.243,0-27.645,12.404-27.645,27.646c0,15.244,12.401,27.646,27.645,27.646   c15.244,0,27.645-12.402,27.645-27.646C72.845,30.981,60.444,18.577,45.2,18.577z M45.2,70.47   c-13.368,0-24.244-10.875-24.244-24.246c0-13.369,10.876-24.246,24.244-24.246c13.369,0,24.245,10.877,24.245,24.246   C69.445,59.595,58.569,70.47,45.2,70.47z" />
                          <polygon points="46.985,26.272 43.585,26.272 43.585,47.925 54.485,47.925 54.485,44.524 46.985,44.524  " />
                          <rect
                            height="4.424"
                            width="3.4"
                            x="43.585"
                            y="61.72"
                          />
                          <rect
                            height="3.4"
                            width="4.36"
                            x="25.229"
                            y="44.524"
                          />
                          <rect
                            height="3.4"
                            width="4.36"
                            x="60.813"
                            y="44.524"
                          />
                          <rect
                            height="3.402"
                            transform="matrix(0.7378 0.6751 -0.6751 0.7378 31.4782 -12.701)"
                            width="4.36"
                            x="29.907"
                            y="32.465"
                          />
                          <rect
                            height="3.401"
                            transform="matrix(-0.738 -0.6748 0.6748 -0.738 62.1598 140.4834)"
                            width="4.356"
                            x="56.174"
                            y="56.474"
                          />
                          <rect
                            height="4.361"
                            transform="matrix(-0.7377 -0.6751 0.6751 -0.7377 17.6811 125.4726)"
                            width="3.399"
                            x="31.514"
                            y="57.121"
                          />
                          <rect
                            height="4.36"
                            transform="matrix(0.7377 0.6751 -0.6751 0.7377 37.3121 -29.9663)"
                            width="3.399"
                            x="55.523"
                            y="30.858"
                          />
                        </g>
                      </svg>
                    </span>
                  )}
                </td>
                <td width="15%" className="text-right">
                  <strong>{transaction.amount}</strong>
                </td>
              </tr>
            );
          }
        );
      }
    } else if (
      !this.state.tileData ||
      this.state.tileData.transactions.length === 0
    ) {
      TotalTransactions = (
        <tr className="no-data">
          <td className="text-center">
            {this.props.content.noTransactionFound}
          </td>
        </tr>
      );
    }
    return (
      <table>
        <tbody>{TotalTransactions}</tbody>
      </table>
    );
  }

  getPanelForMobile() {
    let TotalTransactions;
    if (this.state.tileData && this.state.tileData.transactions.length > 0) {
      if (
        this.state.tileData.transactions.length ===
        this.state.tileData.transactionCount
      ) {
        TotalTransactions = _.map(
          this.state.tileData.transactions,
          (transaction, i) => {
            return (
              <div key={i} className="mobile-row">
                <div className="date">{transaction.date}</div>
                <div className="details">
                  <section>
                    <div className="description">
                      <strong> {transaction.description}</strong>
                    </div>
                    <div className="tag">
                      {transaction.posted ? (
                        <span className="icon icon-tag">{transaction.tag}</span>
                      ) : (
                        <span
                          className="transaction-pending"
                          onClick={this.inProgressPopUp}
                        >
                          <svg
                            enableBackground="new 0 0 91 91"
                            height="28px"
                            id="Layer_1"
                            version="1.1"
                            viewBox="0 0 91 91"
                            width="28px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M45.2,18.577c-15.243,0-27.645,12.404-27.645,27.646c0,15.244,12.401,27.646,27.645,27.646   c15.244,0,27.645-12.402,27.645-27.646C72.845,30.981,60.444,18.577,45.2,18.577z M45.2,70.47   c-13.368,0-24.244-10.875-24.244-24.246c0-13.369,10.876-24.246,24.244-24.246c13.369,0,24.245,10.877,24.245,24.246   C69.445,59.595,58.569,70.47,45.2,70.47z" />
                              <polygon points="46.985,26.272 43.585,26.272 43.585,47.925 54.485,47.925 54.485,44.524 46.985,44.524  " />
                              <rect
                                height="4.424"
                                width="3.4"
                                x="43.585"
                                y="61.72"
                              />
                              <rect
                                height="3.4"
                                width="4.36"
                                x="25.229"
                                y="44.524"
                              />
                              <rect
                                height="3.4"
                                width="4.36"
                                x="60.813"
                                y="44.524"
                              />
                              <rect
                                height="3.402"
                                transform="matrix(0.7378 0.6751 -0.6751 0.7378 31.4782 -12.701)"
                                width="4.36"
                                x="29.907"
                                y="32.465"
                              />
                              <rect
                                height="3.401"
                                transform="matrix(-0.738 -0.6748 0.6748 -0.738 62.1598 140.4834)"
                                width="4.356"
                                x="56.174"
                                y="56.474"
                              />
                              <rect
                                height="4.361"
                                transform="matrix(-0.7377 -0.6751 0.6751 -0.7377 17.6811 125.4726)"
                                width="3.399"
                                x="31.514"
                                y="57.121"
                              />
                              <rect
                                height="4.36"
                                transform="matrix(0.7377 0.6751 -0.6751 0.7377 37.3121 -29.9663)"
                                width="3.399"
                                x="55.523"
                                y="30.858"
                              />
                            </g>
                          </svg>
                        </span>
                      )}
                    </div>
                  </section>
                  <section>
                    <div className="side-content">
                      <strong>{transaction.amount}</strong>
                    </div>
                    <div className="side-content"> {transaction.type} </div>
                  </section>
                </div>
              </div>
            );
          }
        );
      }
    } else if (
      !this.state.tileData ||
      this.state.tileData.transactions.length === 0
    ) {
      TotalTransactions = (
        <div className="mobile-view">
          <p className="no-transaction">
            {this.props.content.noTransactionFound}
          </p>
        </div>
      );
    }
    return TotalTransactions;
  }

  getTileData() {
    let data = '';
    const month = FinancialStoriesBL.getMonthData(
      this.state.selectedMonth
    ).month;
    switch (this.state.tileType) {
      case 'microTransactions':
        data = FinancialStoriesStore.getMicroTransactions(
          this.state.account,
          month
        );
        break;
      case 'insAndOuts':
        data = FinancialStoriesStore.getInsAndOuts(this.state.account, month);
        break;
      case 'cashpoint':
        data = FinancialStoriesStore.getCashpoint(this.state.account, month);
        break;
    }
    this.setState({ tileData: data });
  }

  getTileImageClass() {
    switch (this.state.tileType) {
      case 'cashpoint':
        return 'chocolate-box';
      case 'insAndOuts':
        return 'slinky';
      case 'microTransactions':
        return 'coffee';
      default:
    }
  }

  backToTop() {
    // this.refs.donBtn.focus();
  }

  closeError() {
    FinancialStoriesActionCreator.resetErrorFlag();
  }

  doneClick(e) {
    e.preventDefault();
    InternetBankingActions.navigateToWebTask('WEB-ACCOUNT-DETAILS');
  }

  eventsCall() {
    switch (this.state.tileType) {
      case 'microTransactions':
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_interacted,
          config.analytics.analytics_name_micro_transaction_story,
          'click'
        );
        break;
      case 'cashpoint':
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_interacted,
          config.analytics.analytics_name_cash_withdrawal_story,
          'click'
        );
        break;
      case 'insAndOuts':
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_interacted,
          config.analytics.analytics_name_in_and_out_story,
          'click'
        );
        break;
    }
  }

  inProgressPopUp() {
    this.setState({ inProgressFlag: !this.state.inProgressFlag });
  }

  tileComponentView() {
    const buttonsFooter1 = (
      <button className="c-btn c-btn--default" onClick={this.inProgressPopUp}>
        OK
      </button>
    );
    if (!BrowserUtils.isMobileView()) {
      return (
        <div className="b container-fluid-full scrollable">
          <Helmet title="Financial Stories" />
          <div
            className={`page main-container financial-stories2 account-1 financial-stories-page financial-stories-page-type__${this.state.tileType}`}
          >
            {this.state.inProgressFlag && (
              <PatternLibModalComponent
                show={this.state.inProgressFlag}
                onHide={this.inProgressPopUp}
                bsSize="medium"
                modalHeading="In progress"
                modalBody="This is still going through"
                modalFooter={buttonsFooter1}
                customClass="c-modal"
              />
            )}
            <div className="fc-main-wrapper">
              {this.state.showError ? (
                <ErrorPopUpComponent
                  error={FinancialStoriesStore.getError()}
                  closeErrorPopup={this.closeError}
                />
              ) : (
                ''
              )}
              <div className="row-connery">
                <div className="row-back-button-container">
                  <button
                    className="page-back white"
                    ref="donBtn"
                    onClick={this.doneClick}
                  >
                    <span className="icon icon-page-back" />
                    {this.props.content.back}
                  </button>
                </div>
              </div>
              <div className="inner-wrapper">
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                      <h3 className="statement1 break-line">
                        <span
                          dangerouslySetInnerHTML={{ __html: this.getHeader() }}
                        />
                      </h3>
                      <div className="fc-select">
                        <Select
                          name="select"
                          autoFocus
                          value={this.state.selectedMonth}
                          onChange={this.onMonthChange}
                        >
                          {this.getMonthsList()}
                        </Select>
                      </div>
                      <div className="stmnt-wrapper">
                        <h3 className="statement2">{this.getFooter()}</h3>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                      <div className="banner-img">
                        <div className={this.getTileImageClass()} />
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div className="fc-table">{this.getPanelData()}</div>
                    </div>
                  </div>
                </div>
              </div>
              <p className="back_to_head">
                <a href="javascript:void(0)" onClick={this.backToTop}>
                  <span className="back-to-top-icon">
                    <SvgIcon id="icon-up" width="24px" height="24px" />
                  </span>
                </a>
              </p>
            </div>
          </div>
        </div>
      );
    } else if (BrowserUtils.isMobileView()) {
      return (
        <div className=" b container-fluid-full scrollable">
          <div
            className={`main-container financial-stories2 account-1 financial-stories-page financial-stories-page-type__${this.state.tileType}`}
          >
            <div className="fc-main-wrapper">
              {this.state.showError ? (
                <ErrorPopUpComponent
                  error={FinancialStoriesStore.getError()}
                  closeErrorPopup={this.closeError}
                />
              ) : (
                ''
              )}
              <div className="banner-img">
                <div className={this.getTileImageClass()} />
              </div>
              <div className="row-connery">
                <button
                  className="page-back white"
                  ref="donBtn"
                  onClick={this.doneClick}
                >
                  <span className="icon icon-page-back" />
                  {this.props.content.back}
                </button>
              </div>
              <div className="inner-wrapper">
                <div className="row">
                  <div className="col-xs-12">
                    <h3 className="statement1 break-line">
                      <span
                        dangerouslySetInnerHTML={{ __html: this.getHeader() }}
                      />
                    </h3>
                    <div className="fc-select">
                      <Select
                        name="select"
                        autoFocus
                        value={this.state.selectedMonth}
                        onChange={this.onMonthChange}
                      >
                        {this.getMonthsList()}
                      </Select>
                    </div>
                    <div className="stmnt-wrapper">
                      <h3 className="statement2">{this.getFooter()}</h3>
                    </div>
                  </div>
                </div>
                <div className="fc-mobile-grid">{this.getPanelForMobile()}</div>
              </div>
              <p className="back_to_head">
                <a href="javascript:void(0)" onClick={this.backToTop}>
                  <span className="back-to-top-icon">
                    <SvgIcon id="icon-up" width="24px" height="24px" />
                  </span>
                </a>
              </p>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="spinner-loader">
          <div className="spinner">
            <SvgIcon id="icon-refresh" width="200px" height="200px" />
          </div>
        </div>
      );
    }
  }

  render() {
    return (
      <OrientationSwitch
        backToAccountPage={this.doneClick}
        view={this.tileComponentView}
      />
    );
  }
}

TileComponent.propTypes = {
  content: PropTypes.object,
  data: PropTypes.object,
  tileType: PropTypes.string,
  dropDownData: PropTypes.object,
};
TileComponent.defaultProps = {
  content: {},
};
export default RequiresAuthenticatedUser(TileComponent);
